<div class="customPanel">
  <h1 style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("devices.editSensor")}} {{selectedSensorToEdit.idLuminaria}}
  </h1>

  <div mat-dialog-content class="bodyForm">

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("devices.name")}}</h5>
        <input [(ngModel)]="name" type="text" class="inputWidth textS+">
      </div>
    </div>

    <div *ngIf="user.getPermiso() != 'Ateneo' && (this.selectedSensorToEdit.tipoSensor == 0 || this.selectedSensorToEdit.tipoSensor == 2)"
         style="text-align: center; margin: 5vh auto auto auto; color: white" (click)="goToLimits()" class="textS link">{{this.localiser.get("devices.sensorLimits")}}
    </div>

  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor" mat-button (click)="onCancelClick()">{{this.localiser.get("devices.cancel")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor" mat-button (click)="onSaveClick()">{{this.localiser.get("devices.save")}}</button>
    </div>
  </div>


</div>
